var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:[
    'd-flex d-flex-r type-card mb-05',
    _vm.type,
    { 'is-selected': _vm.isSelected, 'is-disabled': _vm.disabled },
  ],on:{"click":_vm.handleClick}},[_c('div',{staticClass:"type-card-image ml-1 mr-1"}),_c('div',{staticClass:"d-flex d-flex-c d-justify-center type-card-info"},[_c('span',{staticClass:"type-card-title mb-1"},[_c('b',[_vm._v(_vm._s(_vm.title))])]),_c('span',{staticClass:"type-card-detail"},[_vm._v(_vm._s(_vm.detail))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }